export function topMainImageSizing() {
    const area = document.getElementsByClassName('top_main_inner')[0];

    function setClass() {
        let areaHeight = area.clientHeight;
        let areaWidth = area.clientWidth;


        if (areaWidth <= areaHeight) {


            area.classList.add('vertical');
            area.style.fontSize = areaWidth / 100 + 'px';


        } else {


            area.classList.remove('vertical');
            area.style.fontSize = areaHeight / 100 + 'px';


        }


    }

    window.addEventListener('resize', function () {
        setClass();
    })

    setClass();


    window.onload = function() {
        const delay = 500;
        let target = [
            'top_main_copy',
            'top_main_logo',
            'top_main_message',
            'top_main_member'
        ]

        for (let i = 0,len = target.length; i < len; i++){
            let item = document.getElementsByClassName(target[i])[0];

            setTimeout(function () {
                item.classList.add('appear')
            },i * delay)
        }
    }

}

